import React, { useEffect, useState } from "react";
import exportIcon from "../../Assets/export-Icon.svg";
import more from "../../Assets/more.svg";
import QuestionView from "./Responces/QuestionView";
import AnalyticsView from "./Responces/AnalyticsView";
import IndividualView from "./Responces/IndividualView";
import axios from "axios";
import { useParams } from "react-router-dom";

const DataView = () => {
  const [AnalyticsTabActive, setAnalyticsTabaActive] = useState(true);
  const [QuestionTabActive, setQuestionTabActive] = useState(false);
  const [IndividualTabActive, setIndividualTabActive] = useState(false);
  const [userAnswers, setuserAnswers] = useState([]);
  const formId = useParams();
  const [questionViewFrom, setQuestionViewFrom] = useState([]);
  const [formTitle, setFormTitle] = useState("");
  const handelGetUserResponse = async (user) => {
    const Url = process.env.REACT_APP_API;
    try {
      const response = await axios.get(
        `${Url}/forms/${formId.formId}/individual`
      );
      if (response.status === 200) {
        setuserAnswers(response.data);
        console.log(response.data);
        setFormTitle(response.data.formTitle);
        setAnalyticsTabaActive(false);
        setQuestionTabActive(false);
        setIndividualTabActive(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const exportUserResponse = async (formId) => {
    console.log(formId)
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/forms/${formId.formId}/export-table`);
      console.log(res.data);
    } catch (err) {
      console.log("cant export", err);
    }
  };

  const getQuestionView = async (formId) => {
    try {
      const Url = process.env.REACT_APP_API;
      const response = await axios.get(
        `${Url}/forms/${formId.formId}`
      );
      if (response.status === 200) {
        setQuestionViewFrom(response.data);
        setFormTitle(response.data.formTitle);
        setAnalyticsTabaActive(false);
        setQuestionTabActive(true);
        setIndividualTabActive(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getQuestionView(formId);
  }, []);

  return (
    <>
      <div className="secound_header">
        <div className="export-container">
          <div className="exportIcon" onClick={() => exportUserResponse(formId)}>
            <img src={exportIcon} alt="exportIcon" />
            Export
          </div>
          <div className="">
            <img src={more} alt="more" />
          </div>
        </div>
        <div className="formName">{formTitle}</div>
        <div className="responce-count">
          <div className="count">
            <p className="responeCount">3</p>
            <p className="Res-Tex">Responses</p>
          </div>
          <div className="Accepting">
            <p className="Res-Tex">Accepting Question</p>
          </div>
        </div>
      </div>
      <div className="responce-taskpage-topbar">
        <div className="responce-tabs">
          {/* <div
            className="task-tab"
            style={{
              color: AnalyticsTabActive ? "#1B51BB" : "#8493B2",
              fontWeight: AnalyticsTabActive ? "600" : "500",
            }}
            onClick={() => {
              setAnalyticsTabaActive(true);
              setQuestionTabActive(false);
              setIndividualTabActive(false);
            }}
          >
            Analytics
            {AnalyticsTabActive && <div className="form-underline"></div>}
          </div> */}
          <div
            className="task-tab"
            style={{
              color: QuestionTabActive ? "#1B51BB" : "#8493B2",
              fontWeight: QuestionTabActive ? "600" : "500",
            }}
            onClick={() => {
              getQuestionView(formId);
            }}
          >
            Question
            {QuestionTabActive && <div className="form-underline"></div>}
          </div>
          <div
            className="task-tab"
            style={{
              color: IndividualTabActive ? "#1B51BB" : "#8493B2",
              fontWeight: IndividualTabActive ? "600" : "500",
            }}
            onClick={() => {
              handelGetUserResponse();
            }}
          >
            Individual
            {IndividualTabActive && <div className="form-underline"></div>}
          </div>
        </div>
      </div>
      {AnalyticsTabActive && <AnalyticsView />}

      {QuestionTabActive && (
        <QuestionView questionViewFrom={questionViewFrom} />
      )}

      {IndividualTabActive && (
        <IndividualView
          allUser={userAnswers}
          userAnswers={userAnswers.allUsersResponses}
        />
      )}
    </>
  );
};

export default DataView;
